import * as React from "react"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import { SEO } from "../components/organisms/seo"
import { mapToSection } from "../components/sections/section_mapper"

const IndustryPage = ({ data, location }) => {
  const { blocks } = data.butterPage

  return (
    <Layout pathname={location.pathname}>
      <div className="bg-glow-header" />

      {blocks.map((component, index) => mapToSection(component, index))}
    </Layout>
  )
}

export default IndustryPage

// eslint-disable-next-line react/jsx-pascal-case
export const Head = ({ data }) => (
  <>
    {console.log("------")}
    {console.log(data)}
    {console.log(data.butterPage.seo.title)}
    <SEO
      title={`${data.butterPage.seo.title} | Powered by MyRadar`}
      seo_image={data.butterPage.seo.image}
      description={data.butterPage.seo.description}
    />
  </>
)

export const query = graphql`
  query ($slug: String!) {
    butterPage(slug: { eq: $slug }) {
      id
      title
      icon
      seo {
        title
        description
        image
      }
      blocks {
        type
        fields {
          icon
          title
          heading
          body_text
          hubspot_id
          main_image
          main_image_alt_text
          badge_primary_text
          badge_secondary_text
          benefits_list_heading
          benefits_list {
            label
          }
          cta_kind
          cta_label
          cta_link
          secondary_cta_label
          secondary_cta_link
          summary_paragraph
          subheading
          left_column_heading
          left_column_paragraph
          left_column_cta_label
          left_column_cta_link
          logo
          logo_alt_text
          right_column_heading
          right_column_paragraph
          image
          image_alt_text
          image_position
          iframe_src
          iframe_position
          headline
          subheadline
        }
      }
      meta {
        slug
        page_type
      }
    }
  }
`
